<template>
  <div>
    <div class="event-card" :class="showEditBorder" v-show="isEditing === false">
      <h5>{{ event.event }}</h5>
      <div class="divider"></div>
      <p>
        <img src="https://s3.amazonaws.com/s3.pilates.com/img/landing-pages/contrology/icon_date.svg" alt="Calendar icon" class="card-icon">Date: {{ event.date }}<br/>
        <img src="https://s3.amazonaws.com/s3.pilates.com/img/landing-pages/contrology/icon_location.svg" alt="Globe icon" class="card-icon">Location: {{event.location}}<br/>
        <img src="https://s3.amazonaws.com/s3.pilates.com/img/landing-pages/contrology/icon_studio.svg" alt="Location icon" class="card-icon">Studio: {{event.studio}}
      </p>
      <div class="divider"></div>
      <a v-if="event.url" v-show="event.url !== ''" v-bind:href="event.url" target="_blank" class="event-link">Details &amp; Registration</a>
      <h4 style="margin:0" v-if="!event.url">COMING SOON</h4>
      <div class="extra-content" v-show="$route.name==='editevents'">
        <button @click="showForm">Edit</button>
        <button @click="deleteEvent(event)">Delete</button>
      </div>
    </div>

    <div v-show="isEditing === true">
      <label :for="'event-' + event._id">Event Name</label><br>
      <input type="text" :id="'event-' + event._id" v-model="event.event" />
      <div class="divider"></div>
      <p>
        <label :for="'startdate-' + event._id">Start Date (for filtering)</label><br/>
        <input type="text" :id="'startdate-' + event._id" v-model="event.startdate" /><br/>
        <label :for="'enddate-' + event._id">End Date (for filtering)</label><br/>
        <input type="text" :id="'enddate-' + event._id" v-model="event.enddate" /><br/>
        <label :for="'country-' + event._id">Country (for filtering)</label><br/>
        <select v-model="event.country" :id="'country-' + event._id">
          <option v-for="(country, index) in countries" :key="index" :value="country.name">
            {{ country.name }}
          </option>
        </select>
        <label :for="'email-' + event._id">Email (not for display)</label><br/>
        <input type="email" :id="'email-' + event._id" v-model="event.email" /><br/>
        Publish?<br/>
        <input type="radio" :id="'published1-' + event._id" v-model="event.published" value="true" />
        <label :for="'published1-' + event._id">Yes</label>&nbsp;&nbsp;
        <input type="radio" :id="'published2-' + event._id" v-model="event.published" value="false" />
        <label :for="'published2-' + event._id">No</label><br/>
        Joe's Gym?<br/>
        <input type="radio" :id="'jg1-' + event._id" v-model="event.joes_gym" value="true" />
        <label :for="'jg1-' + event._id">Yes</label>&nbsp;&nbsp;
        <input type="radio" :id="'jg2-' + event._id" v-model="event.joes_gym" value="false" />
        <label :for="'jg2-' + event._id">No</label>
      </p>
      <div class="divider"></div>
      <p>
        <img src="https://s3.amazonaws.com/s3.pilates.com/img/landing-pages/contrology/icon_date.svg" alt="Calendar icon" class="card-icon"><label>Date:</label> <input type="text" v-model="event.date" /><br/>
        <img src="https://s3.amazonaws.com/s3.pilates.com/img/landing-pages/contrology/icon_location.svg" alt="Globe icon" class="card-icon"><label>Location:</label> <input type="text" v-model="event.location" /><br/>
        <img src="https://s3.amazonaws.com/s3.pilates.com/img/landing-pages/contrology/icon_studio.svg" alt="Location icon" class="card-icon"><label>Studio:</label> <input type="text" v-model="event.studio" />
      </p>
      <div class="divider"></div>
      <label>Details &amp; Registration URL</label><br>
      <input type="text" v-model="event.url" />
      <div class="extra-content" v-show="$route.name==='editevents'">
        <button @click="updateEvent(event)">Save</button>
        <button @click="hideForm">Cancel</button>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'eventcard',

    props: {
      event: Object,
      isEditing: Boolean,
      countries: Array
    },

    computed: {
      showEditBorder() {
        return this.event.published === false ? "red-border" : "test";
      }
    },

    methods: {
      showForm() {
        this.isEditing = true;
      },

      hideForm() {
        this.isEditing = false;
      },

      updateEvent(event) {
        this.$emit('update-event', event);
      },

      deleteEvent(event) {
        this.$emit('delete-event', event);
      }
    }
  }
</script>

<style lang="scss" scoped>
.event {
  background-color: var(--white);
  padding: 25px 20px;
  margin-bottom: 20px;
  box-shadow: 0px 0px 12px -3px rgba(0,0,0,0.38);
  min-width: 276px;
  width: 100%;
  box-sizing: border-box;
  border-radius: 5px;
  border-bottom: 6px solid var(--black);
}

.event-card {
  display: flex;
  flex-flow: column nowrap;
  height: 100%;
}

h5 {
  font-size: 1em;
  margin: 0;
  color: var(--black);
}

.divider {
  border-top: 1px solid #c4c4c4;
  margin: 15px 0;
}

.event p {
  font-size: .875em;
  line-height: 1.5;
  color: var(--black);
}

.event a.event-link {
  font-size: 1em;
  color: var(--black);
  transition: .2s;
}

.event a.event-link:hover {
  color: gray;
}

.card-icon {
  width: 12px;
  margin-right: 5px;
  margin-bottom: -1px;
}

input,
select {
  width: 100%;
  margin-bottom: 10px;
  padding: 1px 2px;
}

input[type=radio] {
 width: auto;
}

.extra-content {
  display: flex;
  justify-self: flex-end;
  margin-top: auto;
  padding-top: 20px;
}

button {
  width: 40%;
  height: 30px;
  font-size: 1em;
  margin: auto;
  border-color: var(--black);
  background-color: var(--black);
  color: var(--white);
  transition: .2s;
  cursor: pointer;
}

button:hover {
  background-color: #808080;
}

.red-border {
  border: 2px solid red;
}

@media only screen and (max-width:374px) {
  .event {
    width: 100%;
    min-width: 100%;
  }
}

@media only screen and (min-width:803px) {
  .event {
    width: 284px;
    margin-left: 10px;
    margin-right: 10px;
  }
}
</style>
